module.exports = __webpack_public_path__ + "cloud-strategy.2egWCMPf.svg";